import type { useSortable } from '@dnd-kit/sortable';
import { DotsSixVerticalIcon } from '@phosphor-icons/react';

type Sortable = ReturnType<typeof useSortable>;

/**
 * A sortable row's drag handle. Dragging it reorders the row; the up and
 * down arrow keys move it one place by `move`.
 */
export function WorksheetReorderHandle({
  sortable,
  label,
  move,
}: {
  sortable: Pick<Sortable, 'attributes' | 'listeners'>;
  label: string;
  move: (delta: number) => void;
}) {
  return (
    <button
      type="button"
      className="cursor-grab touch-none rounded p-0.5 text-muted-foreground hover:bg-accent focus-visible:outline-2 focus-visible:outline-ring"
      aria-label={label}
      {...sortable.attributes}
      {...sortable.listeners}
      onKeyDown={(event) => {
        const delta =
          event.key === 'ArrowUp' ? -1 : event.key === 'ArrowDown' ? 1 : 0;
        if (!delta) return;
        event.preventDefault();
        move(delta);
      }}
    >
      <DotsSixVerticalIcon size={14} aria-hidden="true" />
    </button>
  );
}
